import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function AdminAlertsPage() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/alerts");
        setAlerts(data);
      } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Falha ao carregar."); }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-alerts-page">
      <div>
        <div className="overline text-accent mb-3">Alertas</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Intervenções recomendadas</h1>
        <p className="text-muted-foreground mt-2">{alerts.length} alertas ativos.</p>
      </div>

      <div className="bg-card border border-border rounded-sm divide-y divide-border">
        {alerts.length === 0 ? (
          <div className="p-10 text-center text-muted-foreground">Nenhum alerta no momento.</div>
        ) : (
          alerts.map((a) => (
            <Link
              key={a.id}
              to={`/admin/pacientes/${a.patient_id}`}
              className="flex items-center gap-4 px-5 py-4 hover:bg-muted transition-colors"
              data-testid={`admin-alert-${a.id}`}
            >
              <AlertTriangle className={`w-5 h-5 flex-none ${a.severity === "high" ? "text-destructive" : "text-warning"}`} />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm">{a.title}</div>
                <div className="text-xs text-muted-foreground">{a.patient_name} · {new Date(a.created_at).toLocaleString("pt-BR")}</div>
              </div>
              <span className={`overline px-2 py-0.5 rounded-sm border ${a.severity === "high" ? "bg-destructive/10 text-destructive border-destructive/30" : "bg-warning/10 text-warning border-warning/30"}`}>{a.severity}</span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
